import { NextSeo } from 'next-seo';

import AssembleLayout from '@/src/layouts/AssembleLayout';
import MainLayout from '@/src/layouts/MainLayout';
import { urlHostResolver } from '@/src/lib/utils';
import ExploreView from '@/src/views/root/ExploreView';

export default function ExplorePage() {
  return (
    <AssembleLayout Layout={MainLayout} Component={ExploreView}>
      <NextSeo
        title="Explore"
        description="Encontre lojas onlines de instituições de ensino parceiras para comprar com praticidade, facilidade e conveniência."
        openGraph={{
          title: 'Explore',
          url: urlHostResolver('/explore'),
        }}
      />
    </AssembleLayout>
  );
}
